export class SlideDeleteError extends Error {}
export class CreateOverlayError extends Error {}
export class TranslateOverlayError extends Error {}
export class RemoveOverlayError extends Error {}
